import React from 'react';
import PropTypes from 'prop-types';
import ResultsTable from '../../components/resultsTable/shared/ResultsTable';
import { getDisabledTabIdsForPeriod } from '../../utils/shared/navigationUtils';
import NavigationBar from '../navigation/NavigationBar';
import Legend from '../legend/shared/Legend';
import './Benchmark.scss';
import renderWidgetsSection from './benchmarkHelper';
import ExtendedTable from '../../components/extendedTable/ExtendedTable';
import {
    DROPDOWN_ITEMS_LENGTH_EQUAL_ONE,
    getGradeTitle,
} from '../../constants/shared/GradesConstants';
import DropDown from '../../components/dropdown/DropDown';
import { SECTION_IDS } from '../../constants/shared/CommonConstants';

const Benchmark = ({
    areResultsUpdating,
    tableSortBy,
    tableRows,
    gridProps,
    isPercentileShown,
    selectedPeriod,
    classNameWrapper,
    classNameNavWrapper,
    isLegendTopPosition,
    switchPeriod,
    currentPeriod,
    legendSections,
    tabs,
    LinkWrapper,
    widgets,
    wrappers,
    isLexileShown,
    featureReportConfig,
    widgetClassName,
    switchGrade,
    selectedGrade,
    dropdownGrades,
    grades,
    isDemoModeOn,
    demoClass,
}) => {
    const { featureReport: FeatureReportContainer } = featureReportConfig;
    const widgetSection = (
        <>
            <div className={`tabs-container container ${classNameNavWrapper}`}>
                <NavigationBar
                    ulTagClassName="nav nav-tabs"
                    tabs={tabs}
                    selectedTabId={selectedPeriod}
                    onNavigationTabClick={switchPeriod}
                    disabledTabIds={getDisabledTabIdsForPeriod(currentPeriod)}
                    LinkWrapper={LinkWrapper}
                />
                {FeatureReportContainer && (
                    <DropDown
                        dropDownClassNames="nav-btn"
                        buttonClassNames="btn-secondary btn-small"
                        dropDownItemClassNames="btn-small"
                        onDropDownItemClick={switchGrade}
                        chosenItem={{
                            uid: selectedGrade,
                            name: getGradeTitle(selectedGrade),
                        }}
                        items={dropdownGrades.map(grade => ({
                            uid: grade,
                            name: getGradeTitle(grade),
                        }))}
                        isDisabled={grades.length === DROPDOWN_ITEMS_LENGTH_EQUAL_ONE}
                    />
                )}
            </div>
            {FeatureReportContainer && <FeatureReportContainer />}
            <div className="container" id={SECTION_IDS.WIDGETS_BENCHMARK}>
                <div className={widgetClassName}>{widgets.map(widget => widget)}</div>
            </div>
        </>
    );
    const legend = (
        <Legend
            sections={legendSections}
            switchProp={selectedPeriod}
            customButtonClassName="benchmark"
            customClassName="container benchmark-legend no-print"
        />
    );
    return (
        <>
            <div className={`container-wrap ${classNameWrapper}`}>
                {renderWidgetsSection(widgetSection, legend, isLegendTopPosition)}
            </div>
            <ExtendedTable
                key={`result-table${isPercentileShown}-${selectedPeriod}-${isLexileShown}`}
                isDemoModeOn={isDemoModeOn}
                tableId="result-table"
                toolTipElId={isDemoModeOn ? `demo-result-table-${demoClass}` : ''} // Force re-rendering the grid when entering Demo mode or switching classes/grades
                sortBy={tableSortBy}
                rows={tableRows}
                gridProps={gridProps}
                areResultsUpdating={areResultsUpdating}
                Table={ResultsTable}
                wrappers={wrappers}
            />
        </>
    );
};
Benchmark.defaultProps = {
    areResultsUpdating: false,
    tableSortBy: {},
    tableRows: [
        {
            rowProperties: {},
            rowObject: {},
        },
    ],
    gridProps: {},
    isPercentileShown: false,
    selectedPeriod: '',
    isLegendTopPosition: false,
    currentPeriod: '',
    classNameWrapper: '',
    classNameNavWrapper: '',
    switchPeriod: () => {},
    legendSections: [],
    tabs: [],
    LinkWrapper: () => {},
    widgets: [],
    wrappers: <></>,
    isLexileShown: false,
    featureReportConfig: {
        isFeatureReportEnabled: false,
        featureReport: <></>,
    },
    widgetClassName: 'widgets',
    switchGrade: () => {},
    selectedGrade: '',
    dropdownGrades: [],
    grades: [],
    isDemoModeOn: false,
    demoClass: '',
};

Benchmark.propTypes = {
    areResultsUpdating: PropTypes.bool,
    tableSortBy: PropTypes.object,
    tableRows: PropTypes.array,
    gridProps: PropTypes.object,
    isPercentileShown: PropTypes.bool,
    selectedPeriod: PropTypes.string,
    isLegendTopPosition: PropTypes.bool,
    currentPeriod: PropTypes.string,
    classNameWrapper: PropTypes.string,
    classNameNavWrapper: PropTypes.string,
    switchPeriod: PropTypes.func,
    legendSections: PropTypes.array,
    tabs: PropTypes.array,
    LinkWrapper: PropTypes.func,
    wrappers: PropTypes.element,
    widgets: PropTypes.array,
    isLexileShown: PropTypes.bool,
    featureReportConfig: PropTypes.object,
    widgetClassName: PropTypes.string,
    switchGrade: PropTypes.func,
    selectedGrade: PropTypes.string,
    dropdownGrades: PropTypes.array,
    grades: PropTypes.array,
    isDemoModeOn: PropTypes.bool,
    demoClass: PropTypes.string,
};

export default Benchmark;
